import React, { useEffect, useState } from 'react'
 
import { useNavigate } from "react-router-dom";
 
import { MegaMenu } from 'primereact/megamenu';
import MyTeamDashboard from './myTeamDashboard';
import TeamRequestApproval from './teamRequesApproval';
import UserWiseApproval from './userWiseApproval';
 

const TeamTravel = () => {
const [currentTab, setCurrentTab] = useState(1);
  const navigate = useNavigate();  


  useEffect(() => {

  }, []);

  const menu1 = [
    {
      label: 'Dashboard',
      icon: 'pi pi-fw pi-file',
      command: () => setCurrentTab(1),
    },
    {
      label: 'Request Approval',
      icon: 'pi pi-pencil',
      command: () => setCurrentTab(2),

    },
    {
      label: 'User Wise Approval',
      icon: 'pi pi-fw pi-user',
      command: () => setCurrentTab(3),
    },
     
  ];
 
 

// const TeamTravel = () => {  
  return (
    <div className="tabview-demo">
      <div className="card mb-3">
      
        <MegaMenu model={menu1} />
      </div>
      <div className="flex grid">
         

        <div className="grid col-12" >
          {currentTab && currentTab == 1 && (

             <MyTeamDashboard /> 
          )}
          {currentTab && currentTab == 2 && (
             <TeamRequestApproval /> 
          )}
          {currentTab && currentTab == 3 && (
              <UserWiseApproval />
          )}

           
        </div>
      </div>
    </div >

  )

          }

 
 export default TeamTravel